<template>
  <div class="row activity activity-non-featured" @click="emitSelectedActivity()">
    <div class="col-md-8">
      <strong>{{ calendarContent.displayName }}</strong>
      <br />
      <span class="activityAdditionalInfo">{{ calendarContent.locationName }}</span>
    </div>
    <div class="col-md-3" v-if="activityDaySchedule.isAllDayEvent">All Day</div>
    <div class="col-md-3" v-if="activityDaySchedule.toBeDetermined">TBD</div>
    <div
      class="col-md-3"
      v-if="!activityDaySchedule.isAllDayEvent && !activityDaySchedule.toBeDetermined"
    >
      <ul class="list-unstyled">
        <li v-for="schedule in activityDaySchedule.schedules" :key="schedule.sortKey">
          <span v-if="schedule.prependText" class="activityMetaLabel">{{schedule.prependText}}<br /></span>  {{ schedule.displayStart }}
          <span v-if="schedule.displayEnd">&mdash; {{ schedule.displayEnd }}</span> <span v-if="schedule.appendText" class="activityMetaLabel"><br />{{schedule.appendText}}</span>
        </li>
      </ul>
    </div>
    <div class="col-md-1 text-right pr-0">
      <button class="btn desktop-only">
        <i class="fa fa-chevron-right"></i>
      </button>
      <button class="btn mobile-only w-100 text-center">
        <a @click="emitSelectedActivity()"><i class="fa fa-chevron-down"></i></a>
      </button> 
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject, computed } from 'vue';
import * as CalendarModel from "../composables/calendar-model";
import * as ContentModel from "../composables/calendar-content-model";

export default defineComponent({
  props: {
    activityDaySchedule: { type: Object as () => CalendarModel.ActivityDayScheduleDto, required: true }
  },
  emits: [ CalendarModel.Event.ActivitySelected ],
  setup(props, context) {
    // Static Properties
    const contentLookup = inject(ContentModel.ContentLookup)!;

    // Reactive Properties
    const calendarContent = computed(() => contentLookup.value.activityById[props.activityDaySchedule.extCalendarId]);

    // Data setup

    // Events
    const emitSelectedActivity = function () {
      context.emit(CalendarModel.Event.ActivitySelected, calendarContent.value, props.activityDaySchedule)
    }
    // Queries

    // Reactions

    // return Model
    return {
      calendarContent,
      emitSelectedActivity
    }
  }
});

</script>
